import React, { useState } from 'react';
export const ContextApp = React.createContext(null);
import {initialState} from './initialState';
import {productsReducer} from './productsReducer';

const initialProductsState = [];

const ContextAppComponent = (props) => {
  const [state, setState] = useState(props.initialState ? props.initialState : initialState);
  const [productsState, setProductsState] = useState(props.initialProductsState ? props.initialProductsState : initialProductsState);
  
  const reducer = (key, payload, valid, error = null) => {
    setState((current) => {
      let stateUpdate = {
        ...current,
        [key]: { ...current[key], value: payload, isValid: valid, error: error },
      }
      return {
        ...stateUpdate
      };
    });
  };

  const productsReducerDispatch = (action) => productsReducer(action, setProductsState);

  return (
    <ContextApp.Provider
      value={{
        globalState: state,
        dispatch: reducer,
        productsState: productsState,
        productsDispatch: productsReducerDispatch,
      }}
    >
      {props.children}
    </ContextApp.Provider>
  );
};

export default ContextAppComponent;
